import { FieldSet } from './styles';

export interface Props {
  children: React.ReactNode;
}

const FieldInput = ({ children }: Props) => {
  return <FieldSet>{children}</FieldSet>;
};
export default FieldInput;
